import axios from 'axios'
const qs = require('qs')

axios.defaults.baseURL = 'http://api-martinsorgel.klangpatenschaft.de'

const service = {
  sendEmail (to, from, subject, emailData) {
    return new Promise((resolve, reject) => {
      axios.post('/', qs.stringify({
        to: to,
        from: from,
        subject: subject,
        emailData: emailData
      }),
      {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-type': 'application/x-www-form-urlencoded'
        }
      })
        .then((response) => {
          resolve(response)
        })
        .catch((response) => {
          reject(response.status)
        })
    })
  }
}

export default service



// WEBPACK FOOTER //
// ./src/service/service.js